@for (rowControls of control.element.gridControls; track rowControls) {
  <div [style]="getDynamicStyle">
    @for (rowControl of rowControls; track rowControl) {
      <div class="grid-item">
        <app-dynamic-control [formGroup]="pageFormGroup"
          [control]="rowControl"
          [viewModel]="viewModel"
        [controlCache]="controls"></app-dynamic-control>
      </div>
    }
  </div>
}
